var i18n = require('i18n');
require('./jquery-qrcode');
var layer;



function  init () {
	var html = `<div class="ui small modal transition hidden dialog-util qrcode">
            <i class="close icon"></i>
            <div class="header">${i18n('share.wx')}</div>
            <div class="content"><p id="qrcode"></p></div>
            <div class="actions">${i18n('share.wx.action')}</div>
          </div>`;
	var node = $(html);
	$('body').append(node);
	$('#qrcode').qrcode({
		width: 256,
		height: 256,
		text: location.href
	});
    node.modal({
        closable  : false,
        width: 200
    }).modal('show');
	return node;
}


module.exports = {
	show: function () {
		if (layer) {
			layer.modal('show');
		} else {
			layer = init();
		}
	},
	hide: function () {
		if (layer) {
			layer.modal('hide');
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/topic/qrcode.js